module.exports = __webpack_public_path__ + "img/c-thermometer-img8-1.2c31c50d.png";